import { useState, useEffect } from 'react';

export function useCountdownByDuration({ hours = 0, minutes = 0 }, key) {
  const [timeLeft, setTimeLeft] = useState('');

  const getRemainingTime = (targetTime) => {
    const now = new Date();
    const diff = targetTime - now;

    if (diff <= 0) return "Time's up!";

    const h = Math.floor(diff / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);

    return `${h}h ${m}m ${s}s`;
  };

  useEffect(() => {
    let targetTime;

    // 1. Check if we already saved this product's countdown end time
    const savedTime = localStorage.getItem(key);
    if (savedTime) {
      targetTime = new Date(savedTime);
    } else {
      // 2. Set new targetTime and store it
      targetTime = new Date();
      targetTime.setHours(targetTime.getHours() + hours);
      targetTime.setMinutes(targetTime.getMinutes() + minutes);
      localStorage.setItem(key, targetTime.toISOString());
    }

    // 3. Update time every second
    const updateTime = () => {
      const remaining = getRemainingTime(targetTime);
      setTimeLeft(remaining);
      if (remaining === "Time's up!") {
        localStorage.removeItem(key); // Optional: clear key when done
      }
    };

    updateTime(); // Run immediately
    const intervalId = setInterval(updateTime, 1000);

    return () => clearInterval(intervalId);
  }, [hours, minutes, key]);

  return timeLeft;
}

export default useCountdownByDuration;